import React from "react";
import styles from "./Footer.module.css";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
// import CartIcon from "../../../assets/images/icons/cart.png";
// import CartIconRV from "../../../assets/images/icons/cart_g.png";
// import UserIcon from "../../../assets/images/icons/user.png";
// import UserIconRV from "../../../assets/images/icons/user_g.png";
// import HomeIcon from "../../../assets/images/icons/home.png";
// import HomeIconRV from "../../../assets/images/icons/home_g.png";
// import GarageIcon from "../../../assets/images/icons/garage.png";
// import GarageIconRV from "../../../assets/images/icons/garage_g.png";
// import LocationIcon from "../../../assets/images/icons/location.png";
// import LocationIconRV from "../../../assets/images/icons/location_g.png";

import { ReactComponent as HomeIcon } from "./../../../assets/svg/footer-home.svg";
import { ReactComponent as CartIcon } from "./../../../assets/svg/footer-cart.svg";
import { ReactComponent as ServicesIcon } from "./../../../assets/svg/footer-centers.svg";
import { ReactComponent as WalletIcon } from "./../../../assets/svg/footer-wallet.svg";
import { ReactComponent as AppointmentIcon } from "./../../../assets/svg/calendar.svg";
import { useTranslation } from "react-i18next";
import { LangLink } from "../LangLink/LangLink";

const Footer = (props) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const { Login } = props;

  const footerList = [
    {
      toPage: "/wallet/",
      icon: WalletIcon,
      alt: "garageicon",
      label: t("common.wallet"),
      condition: location.pathname === "/wallet/",
      isCard: false,
      needUserToken: !Login.token,
    },
    {
      toPage: "/cart/",
      icon: CartIcon,
      alt: "carticon",
      label: t("common.cart"),
      condition: location.pathname === "/cart/",
      // || Login?.cart_data?.total_quantity > 0,
      isCard: true,
      needUserToken: !Login.token,
    },
    {
      toPage: `/${location.search}`,
      icon: HomeIcon,
      alt: "garageicon",
      label: t("common.home"),
      condition: location.pathname === `/${i18n.language}/`,
      isCard: false,
    },
    {
      toPage: "/new-service/",
      icon: ServicesIcon,
      alt: "servicesicon",
      label: t("common.service"),
      condition: location.pathname === "/new-service/",
      isCard: false,
      needUserToken: !Login.token,
    },
    {
      toPage: "/appointment/",
      icon: AppointmentIcon,
      alt: "appointmenticon",
      label: t("common.appointment"),
      condition: location.pathname === "/appointment/",
      isCard: false,
      needUserToken: !Login.token,
    },
  ];

  return (
    <div className="component-footer">
      {footerList.map((footerItem) => {
        return (
          <LangLink
            to={footerItem.needUserToken ? "/login/" : footerItem.toPage}
            className={`component-footer-nav-item ${
              footerItem.condition ? "component-footer-nav-item-selected" : ""
            }`}
          >
            <footerItem.icon
              className={`${styles.FooterIcon} ${styles[footerItem.alt]} ${
                footerItem.condition ? styles.Active : ""
              }`}
            />
            <span
              className={`${styles.FooterItemSubtitle} ${
                footerItem.condition ? styles.Active : ""
              }`}
            >
              {footerItem.label}
            </span>

            <div
              className={`topline ${footerItem.condition ? "active" : ""}`}
            ></div>
            {footerItem.isCard ? (
              Login?.cart_data?.total_quantity ? (
                <span className="footer-cart-quantity">
                  <span className="footer-cart-quantity-text">
                    {Login?.cart_data?.total_quantity}
                  </span>
                </span>
              ) : null
            ) : null}
          </LangLink>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login,
});

export default connect(mapStateToProps)(Footer);
